@defer (when asset()) {
  <article>
    <section>
      <label for="title">Title</label>
      <input id="title" type="text" class="form-control" [(ngModel)]="asset().title" />

      <label for="location">Location</label>
      <input id="location" type="text" class="form-control" [(ngModel)]="asset().location" />
    </section>

    <section class="actions mt-1">
      <div class="text-center">
        <app-button [disabled]="isWorking" label="Cancel" icon="mdi mdi-close" class="mr-1" (click)="cancel()"> </app-button>
        <app-button [disabled]="isWorking" [label]="isWorking ? 'Updating....' : 'Update'" icon="mdi mdi-card-account-mail-outline" (click)="update()"> </app-button>
      </div>
    </section>
  </article>
} @placeholder {
  <i class="mdi mdi-spin-x2 mdi-loading"></i>
}
